/* HTML's autofocus property is stubborn, this will solve that */

export class ClAutofocusDirective implements angular.IDirective {
    public static $name: string = 'clAutofocus';
    public restrict: string = 'A';

    public scope: any = {
        clAutofocus: '<'
    };

    public link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
        if (scope.clAutofocus) {
            this.$timeout(() => {
                element.focus();
            });
        }
    }

    constructor(
        private $timeout: angular.ITimeoutService
    ) { }

    public static Factory() {
        const directive = ($timeout) => {
            return new ClAutofocusDirective($timeout);
        };

        directive['$inject'] = ['$timeout'];

        return directive;
    }
}
